import { render, staticRenderFns } from "./SettingsCredentialsRemoveSecretModal.vue?vue&type=template&id=95f2d678"
import script from "./SettingsCredentialsRemoveSecretModal.vue?vue&type=script&lang=js"
export * from "./SettingsCredentialsRemoveSecretModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95f2d678')) {
      api.createRecord('95f2d678', component.options)
    } else {
      api.reload('95f2d678', component.options)
    }
    module.hot.accept("./SettingsCredentialsRemoveSecretModal.vue?vue&type=template&id=95f2d678", function () {
      api.rerender('95f2d678', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SettingsCredentialsRemoveSecretModal.vue"
export default component.exports